import React from 'react';

import styles from './Nav.module.scss';
import {DEFAULT_MENUS} from "../../shared/constants";
import {NavLink} from "react-router-dom";

const Nav = ({ menus }) => {
    const navMenus = (menus && menus.length) ? menus : DEFAULT_MENUS;

    return (
        <div className={styles.wrapper}>
            {navMenus.map((menu, index) => (
                <div className={styles.menuItemWrapper} key={index}>
                    {menu.isShop ?
                        <NavLink
                            to={menu.url}
                            className={({ isActive }) =>  isActive ? `${styles.menuItem} ${styles.active}` : `${styles.menuItem}`}
                        >
                            {menu.name}
                        </NavLink>
                    :
                        <div className={styles.menuItem} onClick={() => window.location.replace(menu.url)}>{menu.name}</div>
                    }
                    <div className={styles.underline}></div>
                </div>
            ))}
        </div>
    );
};

export default Nav;